import { render } from "./AnimatedBackground.vue?vue&type=template&id=61d1434e"
import script from "./AnimatedBackground.vue?vue&type=script&lang=js"
export * from "./AnimatedBackground.vue?vue&type=script&lang=js"

import exportComponent from "C:\\investmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__